export default __webpack_public_path__ + "static/media/snapchat.42dd7946.png";